module.exports = __webpack_public_path__ + "img/i23.47eab34d.png";